'use strict';

const Manager = require('./Manager');
const App = require('./ManagerApps/App');

class ManagerApps extends Manager {

  static CRUD = {
    ...super.CRUD,
    App,
  }

}

module.exports = ManagerApps;
